import React, {Component} from 'react';
import {Button, Col, Pagination, Popover, Row, Spin} from "antd";
import {api, app} from "../../app";
import config from "../../config";

class RecentClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            page: 1,
            dataList:[]
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.rcList()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 近期开班列表
     */
    rcList = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let params = {
                page,
            }
        let { flag, data, msg, total } = await app.post(api.SkillTrainRecentClass, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ dataList: data, data_loading: false, total: Number(total || 0) })
    }

    // 培训状态名
    trainStatusName = (e) => {
        switch (e) {
            case '0':
                return '未开始'
                break;
            case '1':
                return '进行中'
                break;
            case '2':
                return '已结束'
                break;
        }
    }

    applyName = (e) => {
        switch (e) {
            case '1':
                return '报名中'
                break;
            case '2':
                return '已结束'
                break;
        }
    }

    pushNotice() {
        this.props.history.push('/skillTrain/notice')
    }

    /**
     * 设置值
     * @param data
     */
    setData = (data) => app.setStateSync(this, data)

    render() {
        let { page,total,dataList,data_loading } = this.state
        return(
            <div className="recent-class">
                <div className="list-data">
                    {data_loading?(<div className="mall-loading"><Spin size="large"/></div>):
                        dataList.map((item,index) => {
                            return (
                                <div key={index} className="list-data-r">
                                    <Row type="flex" justify="center">
                                        <Col span={11}>
                                            <Row>
                                                <Col className="list-data-c" span={24}>开班城市：{item.province_name}/{item.city_name}</Col>
                                                <Col className="list-data-c" span={24}>培训课程：{item.train_name}</Col>
                                                <Col className="list-data-c" span={24}>培训科目：{item.names}</Col>
                                                <Col className="list-data-c" span={24}>科目班级：{item.train_class_name}</Col>
                                                <Col className="list-data-c" span={24}>报到时间：{item.check_date}</Col>
                                                <Col className="list-data-c" span={24}>培训时间：{item.start_date}~{item.end_date}</Col>
                                                <Col className="list-data-c" span={24}>考评时间：{item.evaluate_start_date}~{item.evaluate_end_date}</Col>
                                                <Col className="list-data-c" span={24}>考试地点：{item.evaluate_address}</Col>
                                                <Col className="list-data-c" span={24}>发证机构：{item.organization_name}</Col>
                                            </Row>
                                        </Col>
                                        <Col span={11}>
                                            <div className="list-data-right">
                                                <Row>
                                                    <Col className="list-data-c" span={12} offset={12}>招生人数：{item.train_number}人</Col>
                                                    <Col className="list-data-c" span={12} offset={12}>培训天数：{item.train_day}天</Col>
                                                    <Col className="list-data-c" span={12} offset={12}>考评天数：{item.evaluate_day}天</Col>
                                                    <Col className="list-data-c" span={12} offset={12}>考评费用：{item.evaluate_money}元</Col>
                                                    <Col className="list-data-c" span={12} offset={12}>培训费用：{item.train_money}元</Col>
                                                    <Col className="list-data-c" span={12} offset={12}>培训总费用：{item.train_amount}元</Col>
                                                    <Col className="list-data-c" span={12} offset={12}>培训状态：{this.trainStatusName(item.train_status)}</Col>
                                                    <Col className="list-data-c" span={12} offset={12}>报名状态：{this.applyName(item.apply_status)}</Col>
                                                </Row>
                                                <Row type="flex" justify="end" className="row-bottom">
                                                    <Col offset={12} span={5}><Button type="primary" onClick={() =>this.pushNotice()} block>培训通知</Button></Col>
                                                    <Col style={{marginLeft:'15px'}} span={5}>
                                                        <Popover content={<div style={{width:250}}><img style={{width:'100%'}} src={config.imgUrl+item.qrCode_url}/></div>} title="扫码报名">
                                                            <Button type="primary" block>我要报名</Button>
                                                        </Popover>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        })
                    }
                    {dataList.length > 0?
                        <div style={{width:'1000px',textAlign:'right',margin:'15px auto'}}>
                            <Pagination
                                size="small"
                                current={page}
                                total={total}
                                pageSize={20}
                                showTotal={(t) => `总数量：${t}`}
                                onChange={this.rcList}
                            />
                        </div>
                    :<div style={{width:'1000px',textAlign:'center',margin:'15px auto',fontSize:30, paddingTop:100}}>暂无数据</div>}
                </div>
            </div>
        );
    }
}
export default RecentClass;



// WEBPACK FOOTER //
// ./src/routes/skillTrain/RecentClass.jsx